import { Inject } from 'inversify-props'
import type { PedidoServiceAdapter } from './adapter'

export class EnviarPedidoDeVitrineParaApiIntegracaoUseCase {
	@Inject('PedidoServiceAdapter')
	private pedidoServiceAdapter!: PedidoServiceAdapter

	enviar = async (vendaId: string): Promise<void> =>
		await this.pedidoServiceAdapter.enviaPedidoDeVitrineParaApiIntegracao(vendaId)
}
